export default __webpack_public_path__ + "static/media/info-circle.9a3a1721.svg";